import { useTabManager } from '../services/TabManager';
import { useUser } from '../store/context';

export const useRestart = (beforeInvokeRestart?: () => void) => {
  const { closeAllGlobalTabs } = useTabManager();
  const { setIsLoadingApp } = useUser();

  const invokeReload = async () => {
    if (beforeInvokeRestart) beforeInvokeRestart();
    await window.dsDesktop.refetchMe();
    window.location.reload();
  };
  const restartApp = async () => {
    setIsLoadingApp(true);
    await closeAllGlobalTabs();
    window.dsDesktop.speakerPanel.closeFromSpeakerPanelIfOpen({
      resetData: true,
    });
    await invokeReload();
  };

  return { restartApp };
};
